import React from "react";
import { Alert, Col, Container, Form, Row, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { sendingwines_support, vinologix_support } from "../config";
import countries from "../information/countries.json";
import usstates from "../information/USStates.json";
import AnimateWrapper from "../util/AnimateWrapper";
import Recap from "../util/Recap";
import { useBreadcrumbs } from '../util/BreadcrumbContext';
window.Buffer = window.Buffer || require("buffer").Buffer;


const createCsv = (headers, data) => {
    let csvContent = headers.join(",") + "\n" + data;
    return csvContent;
};

const exportContentsToCsv = (data) => {
    const headers = [
        "Omschrijving",
        "Liters",
        "Jaar",
        "Percentage",
        "Tariff No",
        "Land van afkomst",
        "Aantal",
        "Waarde (per stuk)",
        "Waarde (totaal)"
    ];
    return createCsv(
        headers,
        data
            .map((e) =>
                [
                    e.description,
                    e.liters,
                    e.year,
                    e.percentage,
                    e.tariff,
                    e.country,
                    e.amount,
                    e.value,
                    e.totalValue
                ].join(",")
            )
            .join("\n")
    );
};

const exportRecipientToCsv = (data) => {
    const headers = [
        "Name",
        "Company",
        "Nickname",
        "Email Address 1",
        "Phone Type",
        "Phone Number Country Code",
        "Phone Number",
        "VAT / Tax ID",
        "EORI Number",
        "Country Code",
        "Address 1",
        "Address 2",
        "Address 3",
        "ZIP / Postal Code",
        "City"
    ];
    return createCsv(
        headers,
        [
            data.name,
            data.companyName,
            `${data.name} at ${data.companyName} `,
            data.email,
            "m",
            data.telephoneCode,
            data.telephone,
            data.VATNO,
            data.customsNO,
            data.country,
            data.streetno,
            "",
            "",
            data.areaCode,
            data.town
        ].join(",")
    );
};

const Instructions = () => {
    const { state } = useLocation();
    const { addBreadcrumb } = useBreadcrumbs();

    const company = state.countryFrom === "NL" ? "Vinologix" : "SendingWines";
    const countryTo = countries[state.countryTo];
    const stateTo = state.USState ? usstates[state.USState] : undefined;
    const stateToRestrictions =
        stateTo &&
        (stateTo.restrictions ||
            stateTo.max75 ||
            stateTo.state_authorization ||
            stateTo.counties_dry);

    const contact = !state.countryFrom
        ? vinologix_support
        : state.countryFrom === "NL"
            ? vinologix_support
            : sendingwines_support;

    const totalValue = state.contents.reduce((a, b) => a + b.totalValue, 0);

    const sendEmail = () => {
        const contents = window.Buffer.from(exportContentsToCsv(state.contents)).toString("base64");
        const recipient = window.Buffer.from(exportRecipientToCsv(state.recipient)).toString("base64");
        fetch(`${process.env.REACT_APP_BACKEND_URL}/mail/send`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                to: contact,
                countryTo: countryTo.full_name,
                contents,
                recipient,
                sender: state.sender,
                gift: state.gift,
                company,
                name: state.sender.name,
                email: state.sender.email,
                EUR1: state.EUR1 || totalValue >= 6000
            })
        })
            .then((r) => r.json())
            .then(() => addBreadcrumb({
                href: "/success",
                text: "Geslaagd"
            }))
            .catch(e => alert(`Er ging iets mis: ${e}`));
    };

    return (
        <AnimateWrapper>
            <Container className="px-0" fluid>
                {(countryTo.restrictions || stateToRestrictions) && (
                    <Alert variant="danger">
                        {countryTo.restrictions && (
                            <>
                                <span className="fw-bold">
                                    Er zijn restricties voor het versturen van
                                    pakketten naar {countryTo.full_name}:
                                </span>
                                <p>{countryTo.restrictions}</p>
                            </>
                        )}
                        {stateToRestrictions && (
                            <>
                                <span className="fw-bold">
                                    Er zijn specifieke restricties voor het
                                    versturen van pakketten naar{" "}
                                    {stateTo.full_name}:
                                </span>
                                {stateTo.max75 && (
                                    <p>
                                        Maximaal {stateTo.max75} flessen van
                                        75cl.
                                    </p>
                                )}
                                {stateTo.restrictions && (
                                    <p>{stateTo.restrictions}</p>
                                )}
                                {stateTo.state_authorization && (
                                    <p>State authorization is verplicht.</p>
                                )}
                                {stateTo.counties_dry && (
                                    <p>
                                        Sommige counties zijn droog (verkoop van
                                        alcohol verboden).
                                    </p>
                                )}
                            </>
                        )}
                    </Alert>
                )}
                <Row>
                    <Col xs={12} md={5} lg={4} xl={3} className="order-md-last">
                        <Recap state={state} />
                    </Col>
                    <Col>
                        <h2>Instructies</h2>

                        {(state.EUR1 || totalValue >= 6000) && (
                            <>
                                <h3>EUR1 certificaat</h3>
                                <p>
                                    Bij verzendingen met een waarde van €6000 of
                                    hoger, is een gelegaliseerd Certificaat van
                                    Oorsprong (EUR1) verplicht.
                                </p>
                                {state.countryFrom === "NL" ? (
                                    <ol>
                                        <li>
                                            Vraag het EUR1 document aan bij de
                                            Kamer van Koophandel en laat het
                                            door hen legaliseren.
                                        </li>
                                        <li>
                                            Bevestig dit document op het pakket.
                                        </li>
                                    </ol>
                                ) : (
                                    <ol>
                                        <li>
                                            Vraag het EUR1 document aan bij uw
                                            Douanekantoor.
                                        </li>
                                        <li>
                                            Verzendt u met DHL Express? Mail dan
                                            de ingevulde EUR1 plus de proforma
                                            naar{" "}
                                            <a href="mailto:bruexport@dhl.com">
                                                bruexport@dhl.com
                                            </a>{" "}
                                            met vermelding van het
                                            zendingnummer.
                                        </li>
                                        <li>DHL verzorgt de legalisering.</li>
                                        <li>Bevestig de EUR1 op het pakket.</li>
                                    </ol>
                                )}
                                <p>Ga verder zodra u dit gedaan heeft. Bij vragen kunt u een mail versturen naar <a href={`mailto: ${contact}`}>{contact}</a>.</p>
                            </>
                        )}

                        <p>
                            Klik op de knop "Verstuur verzoek" om het verzoek te versturen naar{" "}
                            <a href={`mailto: ${contact}`}>{contact}</a> (zie voorbeeld van de email hieronder):<br />
                        </p>
                        <Form.Control
                            as="textarea"
                            className="mb-2"
                            rows={10}
                            readOnly
                            defaultValue={`Beste klantenservice van ${company},

Ik zou graag een pakket naar ${countryTo.full_name} willen
verzenden met de volgende gegevens${state.gift && " (Het gaat om een geschenk)"}:

Gegevens verzender:
${state.sender.companyName}
${state.sender.name}
${state.sender.streetno}
${state.sender.areaCode}, ${state.sender.town}
${state.sender.country}
+${state.sender.telephoneCode} ${state.sender.telephone}
${state.sender.email}
BTW: ${state.sender.VATNO}
EORI: ${state.sender.customsNO}

${(state.EUR1 || totalValue >= 6000) ? "Let op, het pakket heeft een waarde van 6000 of hoger, dus er dient een EUR1 certificaat bij te zitten." : ""}

De gegevens van de ontvanger zijn te vinden in het bijgevoegde bestand 'recipient.csv' en de inhoud van het pakket in 'contents.csv'.

Met vriendelijke groet,

${state.sender.name}
${state.sender.email}`}
                        />

                        <Button
                            variant="primary"
                            size="lg btn-block"
                            className="w-100"
                            onClick={() => sendEmail()}
                        >
                            Verstuur verzoek
                        </Button>
                    </Col>
                </Row>
            </Container>
        </AnimateWrapper>
    );
};

export default Instructions;
